module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: [
      "info-list",
      {
        'info-list--compact': _vm.compact,
      }
    ]
  }, _vm._l((_vm.sections), function(section, index) {
    return (!section.hidden) ? _c('li', {
      key: index,
      staticClass: "info-list__item"
    }, [_c('module-icon', {
      staticClass: "info-list__icon",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      attrs: {
        "icon": section.icon
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info-list__copy"
    }, [_c('h3', {
      staticClass: "h3 mb0 mt0",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      domProps: {
        "innerHTML": _vm._s(section.title)
      }
    }), _vm._v(" "), _vm._l((section.copy), function(p, index) {
      return _c('p', {
        key: "p" + index,
        staticClass: "small",
        domProps: {
          "innerHTML": _vm._s(p)
        }
      })
    })], 2)], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ebb87a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/InfoList.vue
// module id = 534
// module chunks = 0